module.exports = __webpack_public_path__ + "static/media/formul12.3c9a102e.png";